import { FromStore } from "@abaco/web-common/src/app";
import { plainToClass } from "class-transformer";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { MODULE_ID } from "../index";
import { Subject } from "../models/Subject";
import { ProjectProposal as ProjectProposalModel } from "../models/ProjectProposal";
import { CONVENTIONAL, NO, ORGANIC, YES, NA } from "../models/Form";
import { INPROGRESS, REJECTED, WITHDRAW, CR_WITHDRAWN } from "../models/Contract";
import { ToastOptions } from "@abaco/web-common/src/app/Toasted";
import { TranslateResult } from "vue-i18n";
import { EditablePscState } from "../models/ProjectProposal";

@Component
export default class ProjectProposal extends Vue {
    @FromStore(MODULE_ID) currentContract!: ProjectProposalModel | null;
    @FromStore(MODULE_ID) currentSubject!: Subject;
    @Inject() toast!: (message: string, options?: ToastOptions) => void;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Prop() subjectId!: string;
    @Prop() applicationId!: string;
    @Prop() pageCode!: string;

    get YES() {
        return YES;
    }

    get NO() {
        return NO;
    }

    get NA() {
        return NA;
    }

    get CONVENTIONAL() {
        return CONVENTIONAL;
    }

    get ORGANIC() {
        return ORGANIC;
    }

    get contract(): ProjectProposalModel | null {
        if (this.currentContract instanceof ProjectProposalModel) return this.currentContract;
        if (this.currentContract)
            return plainToClass(ProjectProposalModel, this.currentContract as ProjectProposalModel);
        return null;
    }

    get subject(): Subject | null {
        if (this.currentSubject instanceof Subject) return this.currentSubject;
        if (this.currentSubject) return plainToClass(Subject, this.currentSubject as Subject);
        return null;
    }

    get canEdit() {
        const section = this.contract?.sections.find(s => s.code === this.pageCode);
        const documentCode = section?.documentCode;
        const editableMap = EditablePscState.editableMap; 
        const editableFromMap = documentCode ? editableMap[documentCode] : undefined;
        const fallback = this.contract && this.contract.can_edit && this.isEditableSection(this.pageCode);
        const final = editableFromMap !== undefined ? editableFromMap : fallback;
        return final;
    }

    get canWithdraw() {
        return !this.isReject && !this.isWithdraw;
    }

    get isInProgress() {
        return this.contract && this.contract.application_status_code === INPROGRESS;
    }

    get isReject() {
        return this.contract && this.contract.application_status_code === REJECTED;
    }

    // get isWithdraw() {
    //     return this.contract && this.contract.application_status_code === WITHDRAW ;
    // } old implementation
    
    get isWithdraw() {
        const code = this.contract?.application_status_code;
        return code === WITHDRAW || code === CR_WITHDRAWN;
    }

    // get canSubmit() {
    //     return this.contract && this.contract.can_edit ;
    // }
    get canSubmit() {
        const call = this.contract?.call;
        const intervention = (this.contract?.intervention || '').trim();

        if (
            (intervention === 'I73.5' || intervention === 'I73.5.1') &&
            (call == null || call === 1)
        ) {
            return false;
        }

        return true;
    }
    get isPrintVisible() {
        return !!this.contract && this.contract.intervention === 'I73.5' && this.contract.print_flag === 'S';
        //return !!this.contract && this.contract.print_flag === 'S';
    }

    goHome(replace = false): void {
        this.$router.push({ name: "project-proposal-home", replace });
    }

    goHomeGenericError(): void {
        this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
        this.goHome(true);
    }

    showInfo(tip: string | null) {
        this.$emit("showInfo", tip);
    }

    isEditableSection(code: string) {
        return !!this.contract?.sections.find(x => x.code === code)?.editable;
    }
	isPscClarificationTrue(): boolean {
		return this.contract?.app_status === 'PSC CLARIFICATION';
	}
}
